// extracted by mini-css-extract-plugin
export default {"timeCardContainer":"Style_timeCardContainer__kcv6u","timeCard":"Style_timeCard__R9VYx","icon":"Style_icon__WfaOH","value":"Style_value__cbe7y","timeValue":"Style_timeValue__sVKUy"};